import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cc0b5e50")

_pushScopeId("data-v-cc0b5e50")
const _hoisted_1 = { class: "title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    title: _withId(() => [
      _createVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    body: _withId(() => [
      _createVNode("iframe", {
        class: "frame",
        src: `${_ctx.url}${_ctx.hyphen}token=${_ctx.messageToken}`
      }, null, 8, ["src"])
    ]),
    _: 1
  }))
})